/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { UpdateAllInventoryProps, UpdateInventoryProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "SectionOptionInvPageService";
const log: any = LoggerModule.getInstance();

export class SectionOptionInvPageService {
  private static instance: SectionOptionInvPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): SectionOptionInvPageService {
    if (!SectionOptionInvPageService.instance) {
      SectionOptionInvPageService.instance = new SectionOptionInvPageService(props);
    }
    return SectionOptionInvPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    //UserLists Props
    compProps = await agent.getInventoryProps({
      ...args,
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(content)
    return content;
  }

  public async getFeatures(args: UpdateInventoryProps) {
    log.info(`get features`, args);
    const agent = getAgent();
    return agent.getFeatures(args);
  }
  public async getAttributes(args: UpdateInventoryProps) {
    log.info(`get features`, args);
    const agent = getAgent();
    return agent.getAttributes(args);
  }
  public async getValues(args: UpdateInventoryProps) {
    log.info(`get features`, args);
    const agent = getAgent();
    return agent.getValues(args);
  }
  public async updateInventory(args: UpdateInventoryProps) {
    log.info(`update inventory`, args);
    const agent = getAgent();
    return agent.updateInventory(args);
  }
  public async updateAllInventory(args: UpdateAllInventoryProps) {
    log.info(`update inventory`, args);
    const agent = getAgent();
    return agent.updateAllInventory(args);
  }

  public async getFilterOptions(args: any = {}) {
    const agent = getAgent();
    return agent.getFilterOptions(args);
  }
  // public async getAllValues(args: UpdateAllInventoryProps) {
  //   log.info(`update inventory`, args);
  //   const agent = getAgent();
  //   return agent.getAllInventoryProps(args);
  // }
}
